
import * as actionTypes from "./actionTypes"
import { LkApi, GeneralApi } from "../openapi";

const lkApi = new LkApi();
const generalApi = new GeneralApi();

export function updateMyDatasets() {
  return async (dispatch) => {
    let response = await lkApi.getDatasets();

    if (response.errorMessageRu) {
      console.log(response.errorMessageRu)
    } else {
      const action = {
        type: actionTypes.GET_MY_DATASETS,
        datasets: response.datasets,
        fixedFilters: response.fixedFilters
      }
      dispatch(action)
    }
  }
}

export function selectDataset(dataset) {
  return (dispatch) => {
    const action = {
      type: actionTypes.SELECT_DATASET,
      dataset: dataset
    }
    dispatch(action)
  }
}

export function openLeftPanel(leftPanel) {
  return (dispatch) => {
    const action = {
      type: actionTypes.OPEN_LEFT_PANEL,
      leftPanel: leftPanel
    }
    dispatch(action)
  }
}

export function updTableModal(isOpen, tableName) {
  return (dispatch) => {
    const action = {
      type: actionTypes.SET_UPD_TABLE_MODAL,
      isOpen: isOpen,
      tableName: tableName
    }
    dispatch(action)
  }
}

export function setMetricId(metricId) {
  return (dispatch) => {
    const action = {
      type: actionTypes.SET_METRIC,
      metricId: metricId
    }
    dispatch(action)
  }
}

export function updateUserInfo() {
  return async (dispatch) => {
    const response = await generalApi.userinfo();
    if (response.errorMessageRu) {
      console.log(response.errorMessageRu)
    } else {
      const action = {
        type: actionTypes.SET_USER,
        userInfo: response
      }
      dispatch(action)
    }
  }
}